var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTravelwifilogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 332.92 52.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 287.26,
    cy: 45.81,
    r: 6.39,
    transform: "translate(239.25 332.71) rotate(-89.56)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.38,16.21A49.23,49.23,0,0,0,292.32.08a6.19,6.19,0,0,0-.95-.08,5.55,5.55,0,0,0-5.51,4.49,5.42,5.42,0,0,0,4.44,6.17l.14,0c17.86,3,31,17.93,31.29,35.6v.54a5.6,5.6,0,0,0,11.19,0A46.67,46.67,0,0,0,321.38,16.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M291.34,19a5.44,5.44,0,0,0-1.06-.1,6,6,0,0,0-3.42,1.08,6.15,6.15,0,0,0-2.53,4,6.23,6.23,0,0,0,4.78,7.18l.13,0a15,15,0,0,1,12.17,14.62V46a6.13,6.13,0,0,0,6,6.19h0a5.93,5.93,0,0,0,4.21-1.75A6.22,6.22,0,0,0,313.52,46,27.28,27.28,0,0,0,291.34,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.24,18.81V12.73a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v6.08a1,1,0,0,0,1,1h9a.42.42,0,0,1,.42.42V50.39a1,1,0,0,0,1,1h6.42a1,1,0,0,0,1-1V20.22a.42.42,0,0,1,.42-.42h9A1,1,0,0,0,29.24,18.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.4,23.34c-3.56.53-6.21,2.47-7.1,5.2a.56.56,0,0,1-.59.3c-.24,0-.43-.21-.43-.39V24.78a1,1,0,0,0-1-1H29.05a1,1,0,0,0-1,1V50.39a1,1,0,0,0,1,1h6.24a1,1,0,0,0,1-1V39c0-3.22,2.15-7,8.18-7h.07a1,1,0,0,0,.72-.29,1,1,0,0,0,.29-.7V24.33a1,1,0,0,0-.34-.75A1,1,0,0,0,44.4,23.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.41,23.3H71.56a1,1,0,0,0-1,1v1.3a.42.42,0,0,1-.27.39.44.44,0,0,1-.47-.11c-1.94-2.25-4.74-3.39-8.3-3.39-7.51,0-13.4,6.53-13.4,14.85S54,52.19,61.52,52.19c3.56,0,6.36-1.13,8.31-3.38a.41.41,0,0,1,.73.28v1.3a1,1,0,0,0,1,1h5.85a1,1,0,0,0,1-1V24.3A1,1,0,0,0,77.41,23.3ZM63.26,44.82c-4.44,0-7.3-2.93-7.3-7.48s2.86-7.47,7.3-7.47,7.3,3,7.3,7.47S67.63,44.82,63.26,44.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.87,23.3h-6.55a1,1,0,0,0-.94.69l-5.7,17.36a.42.42,0,0,1-.8,0L90.18,24a1,1,0,0,0-.94-.69H82.69a1,1,0,0,0-.93,1.34l9.65,26.1a1,1,0,0,0,.94.65h7.86a1,1,0,0,0,.93-.65l9.66-26.1a1,1,0,0,0-.93-1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.19,22.49c-8.67,0-15,6.25-15,14.85a14.68,14.68,0,0,0,4.17,10.57,15.85,15.85,0,0,0,11.43,4.28c4.71,0,8.48-1.5,11.2-4.46a1,1,0,0,0,.25-.82,1,1,0,0,0-.49-.71l-4.6-2.65a1,1,0,0,0-1.11.08A8.44,8.44,0,0,1,128,45.28c-3.82,0-6.29-1.45-7.34-4.32a.42.42,0,0,1,0-.39.43.43,0,0,1,.34-.18h19.34a1,1,0,0,0,1-.86,17.39,17.39,0,0,0,.14-2.19C141.47,28.88,135.33,22.49,127.19,22.49Zm6.41,12.1a.43.43,0,0,1-.33.17H120.83a.43.43,0,0,1-.33-.17.41.41,0,0,1-.07-.37c.86-3.14,3.24-4.87,6.71-4.87a6.28,6.28,0,0,1,6.53,4.88A.39.39,0,0,1,133.6,34.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212,11.73H205.2a1,1,0,0,0-1,.76L197.5,39.76a.42.42,0,0,1-.39.32.44.44,0,0,1-.43-.31l-7.52-27.31a1,1,0,0,0-1-.73h-5.36a1,1,0,0,0-1,.73l-7.53,27.31a.41.41,0,0,1-.39.31.43.43,0,0,1-.42-.32l-6.73-27.27a1,1,0,0,0-1-.76h-6.75a1,1,0,0,0-1,1.26l10.39,37.67a1,1,0,0,0,.95.73h8.38a1,1,0,0,0,1-.73l6.3-22.86a.43.43,0,0,1,.41-.31.41.41,0,0,1,.4.31l6.31,22.86a1,1,0,0,0,1,.73h8.37a1,1,0,0,0,1-.73L212.91,13a1,1,0,0,0-1-1.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 216.83,
    y: 23.3,
    width: 7.84,
    height: 28.08,
    rx: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M258.88,23.3H240.64a.42.42,0,0,1-.42-.42c0-2.88,1.48-4.4,4.42-4.51a1,1,0,0,0,1-1V11.87a1,1,0,0,0-1-1h-.09c-4,0-7.13,1.08-9.18,3.21s-3,5-3,8.79a.42.42,0,0,1-.42.42H229.5a1,1,0,0,0-1,1v5.5a1,1,0,0,0,1,1H232a.42.42,0,0,1,.42.42V50.39a1,1,0,0,0,1,1h5.85a1,1,0,0,0,1-1V31.21a.42.42,0,0,1,.42-.42h11a.42.42,0,0,1,.42.42V50.39a1,1,0,0,0,1,1h5.85a1,1,0,0,0,1-1V24.3A1,1,0,0,0,258.88,23.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.75,10.34a4.79,4.79,0,1,0,4.78,4.79A4.86,4.86,0,0,0,220.75,10.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.62,10.34a4.79,4.79,0,1,0,4.79,4.79A4.85,4.85,0,0,0,256.62,10.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 145.89,
    y: 11.63,
    width: 7.84,
    height: 39.76,
    rx: 0.99
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelwifilogo);
export default __webpack_public_path__ + "static/media/travel wifi logo.310a198f1ec2f6c539700be1dd3c816c.svg";
export { ForwardRef as ReactComponent };